import request from '@/plugins/axios'

/** S รายการร้านค้า **/
// รายการร้านค้า
export const apiShopLists = (params: any) => request.get('/shop.shop/lists', {params})

// เพิ่มร้านค้า
export const apiShopAdd = (params: any) => request.post('/shop.shop/add', params)

// รายละเอียดร้านค้า
export const apiShopDetail = (params: any) => request.get('/shop.shop/detail', {params})

// แก้ไขร้านค้า
export const apiShopEdit = (params: any) => request.post('/shop.shop/edit', params)

// ลบร้านค้า
export const apiShopDelete = (params: any) => request.post('/shop.shop/delete', params)

// แก้ไขผู้ดูแลระบบระดับสูง
export const apiShopChangeSuperAdmin = (params: any) => request.post('/shop.shop/changeSuperAdmin', params)

// ปรับเปลี่ยนสถานะร้านค้า
export const apiShopSwitchStatus = (params: any) => request.post('/shop.shop/switchStatus', params)

// แพ็คเกจประวัติศาสตร์
export const apisetMealLogLists = (params: any) => request.get('/shop.shop/setMealLogLists', {params})

// ปรับเปลี่ยนข้อสังเกตของร้านค้า
export const apiChangeRemark = (params: any) => request.post('/shop.shop/changeRemark', params)
/** E รายการร้านค้า **/

/** S รายการแพ็คเกจ **/
// รายการแพ็คเกจ
export const apiSetMealLists = (params: any) => request.get('/shop.set_meal/lists', {params})

// เพิ่มแพ็คเกจ
export const apiSetMealAdd = (params: any) => request.post('/shop.set_meal/add', params)

// รายละเอียดแพ็คเกจ
export const apiSetMealDetail = (params: any) => request.get('/shop.set_meal/detail', {params})

// แก้ไขแพ็คเกจ
export const apiSetMealEdit = (params: any) => request.post('/shop.set_meal/edit', params)

// ลบแพ็คเกจ
export const apiSetMealDelete = (params: any) => request.post('/shop.set_meal/del', params)

// ปรับเปลี่ยนสถานะแพ็คเกจ
export const apiSetMealSwitchStatus = (params: any) => request.post('/shop.set_meal/status', params)

export const apiMealModule = () => request.get('/shop.set_meal/getMealModule')
/** E รายการแพ็คเกจ **/

